export class GCSBuckets {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "buckets",
            "baseName": "buckets",
            "type": "Array<GCSBucket>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GCSBuckets.attributeTypeMap;
    }
    constructor() {
    }
}
